<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates30">
<p class="centerImage"><img alt="images" id="plate30" src="images/plate30.jpg"/></p>
<p class="caption">Some of the boys: From left, Sgt Jimmy Wellsman, PO George Ferries, FO Tony Tuckson, FO John Lenagen, FO D F Evans, RWF, PO D Downes, PO Tony Brook, PO F S Young, Sgt David Wheeler, FO Ernie Weatherhead (Adj), FL Robin Norwood, PO A McIntyre.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates30.vue?2aef3936